import { memo, useEffect, useRef, useState } from 'react'
import type { WorldMap, Box } from './geometry'
import { areaKey, CHUNK } from './artModel'
import { artMetrics, chunkBoxes, loadArt, renderChunk, RES } from './artRenderer'

export type MapArtStatus='loading'|'ready'|'failed'
type Props={map:WorldMap;view:Box&{cs:number};onStatus:(status:MapArtStatus)=>void}
function Layer({map,view,onStatus}:Props){
  const ref=useRef<HTMLCanvasElement>(null),[retry,setRetry]=useState(0),[failed,setFailed]=useState(false)
  useEffect(()=>{
    let cancelled=false;onStatus('loading');setFailed(false)
    const canvas=ref.current!;canvas.dataset.ready='false';const scale=Math.min(window.devicePixelRatio||1,1.5),width=view.cols*view.cs,height=view.rows*view.cs
    canvas.width=Math.ceil(width*scale);canvas.height=Math.ceil(height*scale)
    const g=canvas.getContext('2d');if(!g){setFailed(true);return}
    g.scale(scale,scale)
    void (async()=>{try{
      const assets=await loadArt()
      for(const [cx,cy]of chunkBoxes(view)){
        await new Promise<void>(resolve=>requestAnimationFrame(()=>resolve()));if(cancelled)return
        const chunk=renderChunk(map,cx,cy,assets)
        g.drawImage(chunk,0,0,CHUNK*RES,CHUNK*RES,(cx*CHUNK-view.x0)*view.cs,(cy*CHUNK-view.y0)*view.cs,CHUNK*view.cs,CHUNK*view.cs)
      }
      if(!cancelled){canvas.dataset.renders=String(artMetrics.renders);canvas.dataset.cacheBytes=String(artMetrics.cacheBytes);canvas.dataset.renderMs=String(Math.round(artMetrics.renderMs));canvas.dataset.ready='true';canvas.dataset.cs=String(view.cs);canvas.dataset.cols=String(view.cols);onStatus('ready')}
    }catch{if(!cancelled){setFailed(true);onStatus('failed')}}})()
    return()=>{cancelled=true}
  },[map,view,onStatus,retry])
  return <><canvas ref={ref} className="map-art" aria-hidden="true" style={{width:view.cols*view.cs,height:view.rows*view.cs}} />{failed&&<button className="map-art__retry" onClick={()=>setRetry(n=>n+1)}>Оформление не загрузилось · повторить</button>}</>
}
/** Timer/poll updates must not clear the canvas. Only static content or the window matters. */
export const MapArt=memo(Layer,(a,b)=>a.onStatus===b.onStatus&&a.view.x0===b.view.x0&&a.view.y0===b.view.y0&&a.view.rows===b.view.rows&&a.view.cols===b.view.cols&&a.view.cs===b.view.cs&&(a.map===b.map||areaKey(a.map,a.view)===areaKey(b.map,b.view)))
